<template>
  <section class="not-found">
    <h1 class="not-found__title">{{ $t("errors.404") }}</h1>
    <h2 class="not-found__subtitle">{{ $t("errors.page-not-found") }}</h2>
  </section>
</template>

<script>
export default {
  name: "NotFound"
};
</script>

<style scoped lang="scss">
.not-found {
  margin: 50px 20px;

  &__title {
    color: $color-blue-300;
    font-size: $font-size-xl;
  }

  &__subtitle {
    font-size: $font-size-l;
    color: $color-grey-400;
  }
}
</style>
